
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/unternehmen",
      function () {
        return require("private-next-pages/[locale]/unternehmen.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/unternehmen"])
      });
    }
  